import { MediaTypes } from './enums';

export const getMediaType = (url: string) => {
  return url?.endsWith('.mp4') ? MediaTypes.Video : MediaTypes.Image;
};
